import { IPortalAppContext } from "./appContext";
import { PortalLayout } from "Components/Api/GeneratedDTOs/ViewModels/Shared/PortalLayout";
import { configureFetchers } from "./configureFetchers";
import { FlashMessageCallback, OpenConfirmationCallback, OpenDialogCallback, RegisterBeforeUnloadCallback } from "spry-react/App/app";
import { SetWindowLocationHrefCallback } from "spry-react/SerialOperation/setWindowLocationHref";
import { StartSerialOperationCallback } from "spry-react/SerialOperation/serialOperation";
import { CrossSiteRequestForgeryTokenInfo } from "spry-react/utils/fetchExtensions";
import { ClaimsUrls } from "Components/Claims/claimsRoutes";
import { LoginUrls } from "Components/Login/loginRoutes";

export interface AppCallbacks {
  openDialog: OpenDialogCallback;
  registerBeforeUnload: RegisterBeforeUnloadCallback;
  flashMessage: FlashMessageCallback;
  confirm: OpenConfirmationCallback;
  setWindowLocationHref: SetWindowLocationHrefCallback;
  startSerialOperation: StartSerialOperationCallback;
}

/** Builds the IPortalAppContext object. */
export function buildContext(
  layout: PortalLayout,
  appCallbacks: AppCallbacks,
  getCsrfInfo: () => CrossSiteRequestForgeryTokenInfo,
  isClientSidePage: boolean,
): IPortalAppContext {
  const fetchers = configureFetchers(appCallbacks.openDialog, appCallbacks.startSerialOperation, getCsrfInfo, layout.jsonCommandApiUrls);
  
  return {
    fetcher: fetchers.serialFetcher,
    commandFetcher: fetchers.commandFetcher!,
    serialOperationApiClient: fetchers.serialOperationApiClient,
    standardApiClient: fetchers.standardApiClient,
    csrfOnlyApiClient: fetchers.csrfOnlyApiClient,
    loaderApiClient: fetchers.loaderApiClient,
    openDialog: appCallbacks.openDialog,
    confirm: appCallbacks.confirm,
    flashMessage: appCallbacks.flashMessage,
    registerBeforeUnload: appCallbacks.registerBeforeUnload,
    setWindowLocationHref: appCallbacks.setWindowLocationHref,
    startSerialOperation: appCallbacks.startSerialOperation,
    
    homeUrl: layout.loggedInUser ? ClaimsUrls.list() : LoginUrls.login(),
    loggedInUser: layout.loggedInUser,
    timeTravelDate: null, //todo: layout.timeTravelDate
    portalSiteLinks: layout.portalSiteLinks,
    enableNotificationChecking: false,
    getCsrfInfo: getCsrfInfo,
    logoColor: '', //todo: layout.logoColor
    logoLabel: '', //todo: layout.logoLabel
    noRouter: !isClientSidePage,
  };
}
